

function youtube_parser($url){

    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    var match = $url.match(regExp);
    return (match&&match[7].length==11)? match[7] : false;

}

import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import LazyYoutubeVideo from "vue-lazy-youtube-video";
import "swiper/css/swiper.css";
import Kirbyimage from '../kirbyimage.vue';
export default {
  name: "slideshowDefault",
  props:{
      content: Object
  },
  components: {
    Swiper,
    SwiperSlide,
    LazyYoutubeVideo,
    Kirbyimage
  },
  directives: {
    swiper: directive,
  },
  methods:
    {
        onSlideClick: function(index) {
          console.log(this.$refs.swipercon);
          //this.$refs.swiper.swipeTo(index);
        },
        getYoutubeID($url){
          let ytID = youtube_parser($url);
          return 'https://www.youtube.com/embed/' + ytID;
        }  
    },
  data() {
    return {
      swiperOptions: {
        loop: false,
        allowSlideNext: true,
        allowSlidePrev: true,
        allowTouchMove: true,
        simulateTouch: true,
        shortSwipes: true,
        slideToClickedSlide: true,
        breakpoints: {
          "1" : {
            slidesPerView: 2,
            spaceBetween: 4,
          },
          "1080" :{
            slidesPerView: 3,
            spaceBetween: 30,

          }

        },
        centeredSlides: true,
      }
    };
  },
};
